export default {
  init() {
    function loginHourly() {
      $('#login-content').toggle();
      document.getElementById('login-content').focus();
    }

    function loginChat() {
      document.getElementById('___$_4 ___$_4').focus();
    }

    //$(".fancybox").fancybox();
    $('#account-select-link').fancybox({
      showCloseButton: true,
      afterShow: function () {
        $('.fancybox-wrap').attr("tabindex", 1);
        $(this.content).attr("tabindex", 1);
        $('.remove-account-button').attr("tabindex", 1);
        $('.form-text-account-input#newAccount').attr("tabindex", 1).trigger('focus');
        $('#newAccountZip').attr("tabindex", 1);
        $('#add-account-form-submit').attr("tabindex", 1);
        $('#add-account-form-cancel').attr("tabindex", 1);
      }
    }).on('click', function() {
      $('.fancybox-wrap').attr("tabindex", 1);
      $('.remove-account-button').attr("tabindex", 1);
      $('.form-text-account-input#newAccount').attr("tabindex", 1).trigger('focus');
      $('#newAccountZip').attr("tabindex", 1);
      $('#add-account-form-submit').attr("tabindex", 1);
      $('#add-account-form-cancel').attr("tabindex", 1);
    });

    // authorize
    $.ajax({
      url: '/rrtpbillcompare/Servlet?type=auth',
      success: function (data) {
        if (data.length > 0) {
          if (data.indexOf('false') >= 0) {
            window.location.href = '/';
          } else {
            if ($.trim(data) == '$(\'body\').show();') {
              $('body').show();
            }
          }
        }
      },
      cache: false,
      async: false,
    });

    // logout
    $('#logout-button').click(function () {
      window.location.href = '/rrtpbillcompare/Servlet?type=logout';
    });
    $('.desktop-button #logout-button').on('click', function () {
      window.location.href = '/rrtpbillcompare/Servlet?type=logout';
    });

    // load accounts
    $.ajax({
      url: '/rrtpbillcompare/Servlet?type=accountoptions',
      success: function (data) {
        data.forEach(el => {
          const account = $('<div>').text(el.account).text();
          const rrtpId = $('<div>').text(el.rrtpId).text();
          const accountNum = $('<div>').text(el.accountNum).text();

          const option ='<option data-rrtp="' + rrtpId + '" value="' + account + '">' + accountNum + '</option>';
          $('#account').append(option);
        });
        
        // on load, set the default acct if available
        if ($.cookie('rrtpacctindex') && $("#account-select #account option[data-rrtp='" + $.cookie('rrtpacctindex') + "']").length > 0) {

          // lookup account using rrtpid
          var account = $("#account-select #account option[data-rrtp='" + $.cookie('rrtpacctindex') + "']").val();

          // set <select> val
          $('#account-select #account').val(account);
        }
      },
      cache: false,
      async: false,
    });

    // select account
    $('#account-select #account').change(function () {
      $('.highcharts-spinner').show();

      // save RRTPID in cookie

      // determine if https or http (local vs remote)
      var secure_param = true;
      if (window.location.protocol == 'http:') {
        secure_param = false;
      }

      // Delete any preexisting cookie. Rewriting doesn't work
      $.removeCookie('rrtpacctindex',
        {
          path: '/',
          secure: secure_param
        });

      // Save JS client cookie
      var result = $.cookie(
        'rrtpacctindex',
        $('#account-select #account option:selected').attr('data-rrtp'),
        {
          expires: 7,
          path: '/',
          secure: secure_param
        }
      );

      // reload page asynchronously
      mhpa.loadAccountData();
    });

    // load manage accounts
    $.ajax({
      url: '/rrtpbillcompare/Servlet?type=manageaccounts',
      success: function (data) {
      
        let manageAcctsCodeBlock = '';
        
        data.forEach(el => {
          let escapedAccount = $('<div>').text(el.account).text();
          let escapedAccountNum = $('<div>').text(el.accountNum).text();

          manageAcctsCodeBlock = "<span style='display: block'><div class='existing-account-data' id='account" + escapedAccount + "'>" + escapedAccountNum + "</div>" + "<div class='remove-account'><input class='remove-account-button' type='button' name='" + escapedAccount + "' value='Remove'></div></span>";

          $('#manage-account-header').append(manageAcctsCodeBlock);
        });
      },
      cache: false,
      async: false,
    });

    // handle delete account
    $('.remove-account-button').click(function () {
      var name = this.name;
      // underscore the line
      $('#account' + name).addClass('line-through');
      $('#zip' + name).addClass('line-through');
      $('#deleteAccounts').val($('#deleteAccounts').val() + this.name + ';');
    });
    /*$('#newAccount').click(function () {
      $('#newAccount').text(function (index, text) {
        $('#newAccount').val(text.replace('Enter New Number', ''));
      });
    });*/
    /*$('#newAccountZip').click(function () {
      $('#newAccountZip').text(function (index, text) {
        $('#newAccountZip').val(text.replace('Zip Code', ''));
      });
    });*/
    $('#add-account-form-cancel').click(function () {
      $('#deleteAccounts').val('');
      $('#newAccount').val('Enter New Number');
      $('#newAccountZip').val('Zip Code');
      $('.line-through').removeClass('line-through');
      $.fancybox.close();
    });
    $('#add-account-form-submit').click(function () {
      if ($('#newAccount').val().trim() == 'Enter New Number' && $('#newAccountZip').val().trim() == 'Zip Code' && $('#deleteAccounts').val().trim() == '') {
        alert('No actions selected. Please make a selection or press Cancel to close the dialog.');
      } else {
        $.post('/rrtpbillcompare/Servlet?activity=manage-accounts-form-submit', $('#add-account-form').serialize()).done(function (data) {
          $('#deleteAccounts').val('');
          $('#newAccount').val('Enter New Number');
          $('#newAccountZip').val('Zip Code');
          $('.line-through').removeClass('line-through');
          $.fancybox.close();
          alert(data);
          self.location.reload();
        });
      }
    });

    // static account
    var acct = getUrlParameter('account');
    //console.log(acct);
    $('#accountStatic').text(acct);

    // user name
    $.ajax({
      url: '/rrtpbillcompare/Servlet?type=userfirstname',
      success: function (data) {
        $('#welcome').text('Welcome ' + data);
      },
      cache: false,
      async: false,
    });

    // nav
    var p = window.location.pathname;
    if (p.indexOf('bc-dashboard') >= 0) {
      $('#menu-nav #bc-dashboard').addClass('current_page_item');
    } else if (p.indexOf('bc-savings') >= 0) {
      $('#menu-nav #bc-savings').addClass('current_page_item');
    } else if (p.indexOf('bc-graphs') >= 0) {
      $('#menu-nav #bc-graphs').addClass('current_page_item');
    } else if (p.indexOf('bc-rewards') >= 0) {
      $('#menu-nav #bc-rewards').addClass('current_page_item');
    } else if (p.indexOf('bc-settings') >= 0) {
      $('#menu-nav #bc-settings').addClass('current_page_item');
    }
    $('#menu-nav .menu-item').click(function () {
      $('#menu-nav .menu-item').removeClass('current_page_item');
      $(this).addClass('current_page_item');
    });

    function getUrlParameter(sParam) {
      var sPageURL = window.location.search.substring(1);
      var sURLVariables = sPageURL.split('&');
      for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) {
          return sParameterName[1];
        }
      }
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};